// extracted by mini-css-extract-plugin
export default {"link":"HeadPage_link__SU1oJ","lastLink":"HeadPage_lastLink__PnlZD"};